import Dispatcher from '../Dispatcher';
import TourActionTypes from './TourActionTypes';

const Actions = {
    // Actions shouldnt be setters.
    setAppState(appState) {
        Dispatcher.dispatch({
            type: TourActionTypes.UPDATE_STATE,
            appState,
        });
    },
};

export default Actions;
